export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const SHOW_CUSTOMER = 'SHOW_CUSTOMER';
export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS';
export const CUSTOMER_ERROR = 'CUSTOMER_ERROR';

